import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { adcivesFor } from "./helper"
import AdviceToTourist from "components/AdviceToTourist"
import { useEffect } from "react"
import visitor from "services/visitor"
import FullScreen from "components/Spinner/FullScreen"
import UserDatasCarousel from "components/Carousel/UserDatasCarousel"
import Empty from "components/Empty"
import MapCards from "components/Cards/MapCards"
import ViewCardsSlider from "components/Carousel/ViewCardsSlider"
import { useTranslation } from "react-i18next"
import { classNames } from "utils/classNames"
import { useShowAlert } from "hooks/customAlert"
import L from "leaflet"
import { FiArrowLeft } from "react-icons/fi"

export default () => {
  const [works, setWorks] = useState([])
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const { t } = useTranslation()
  const [userLocation, setlUserLocation] = useState({})
  const { error } = useShowAlert()

  const getAll = () => {
    const postData = {
      page: 1,
      limit: 1000,
      seen: "seen",
    }
    setLoading(true)
    visitor
      .getVisitorDatas(postData)
      .then((res) => {
        setWorks(res.docs)
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      const latlng = new L.LatLng(
        parseFloat(position.coords?.latitude),
        parseFloat(position.coords?.longitude)
      )
      setlUserLocation(latlng)
    })
    getAll()
    window.scrollTo({ top: 0, left: 0 })
  }, [refresh])

  // const handleClick = () => {
  //   alert("Map is opening !")
  // }

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 })
  })

  const handleCardClickRoute = (data) => {
    if (
      Object.keys(userLocation)?.length &&
      data.media[0]?.lat &&
      data.media[0]?.lng
    ) {
      window.open(
        `https://www.google.com/maps/dir/${userLocation?.lat},${userLocation?.lng}/${data.media[0]?.lat},${data.media[0]?.lng}/@40.8519793,69.3912986,8z/data=!3m1!4b1!4m2!4m1!3e0`
      )
    } else {
      error(t("error-route"))
    }
  }

  if (loading) return <FullScreen />
  return (
    <div className="text-black">
      <div className="flex items-center justify-between">
        <div className="flex items-center justify-between gap-1">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-start gap-1 text-base"
          >
            <FiArrowLeft size={25} />
          </button>
          <span className="ml-5 text-xl font-medium">
            {t("seen-buildings")}
          </span>
        </div>
        {/* <div className="items-center justify-between hidden gap-5 md:flex sm:hidden">
          <UserInformation />
        </div> */}
      </div>
      <div className="md:hidden">
        <UserDatasCarousel
          setRefresh={setRefresh}
          data={works}
          FullImage
          setLoading={setLoading}
        />
      </div>
      <div className="justify-center hidden mt-10 md:flex">
        <div
          className={`flex ${classNames(
            works?.length ? "justify-start" : "justify-center"
          )} gap-5 flex-wrap w-full items-start`}
        >
          {works?.length ? (
            works.map((item, indx) => (
              <MapCards
                setRefresh={setRefresh}
                setLoading={setLoading}
                data={item}
                key={`${indx * 2}`}
                onClick={() => handleCardClickRoute(item)}
              />
            ))
          ) : (
            <div className="col-span-5 row-span-2 h-[70vh] flex justify-center items-center">
              <Empty message="not-found-text" />
            </div>
          )}
        </div>
        <div className="relative hidden px-1 lg:block md:w-4/12 xl:w-3/12">
          <AdviceToTourist
            // handleClick={handleClick}
            title="advices-for-tourist"
            adcivesFor={adcivesFor}
          />
        </div>
      </div>
      <div>
        <ViewCardsSlider
          setRefresh={setRefresh}
          loading={loading}
          setLoading={setLoading}
        />
      </div>
    </div>
  )
}
